import { create } from 'zustand';
import {
  defaultProgress,
  migrateProgress,
  type StorageProvider,
  type UserProgress,
} from '../progression/StorageProvider';
import { createStorageProvider } from '../progression/IndexedDBProvider';
import { applyAttempt, type ApplyResultOutcome } from '../progression/progressModel';
import type { AttemptResult } from '../levels/Evaluator';

interface ProgressState {
  loaded: boolean;
  progress: UserProgress;
  hydrate: () => Promise<void>;
  recordAttempt: (result: AttemptResult) => ApplyResultOutcome;
  isLevelUnlocked: (id: string) => boolean;
  isCarUnlocked: (id: string) => boolean;
  resetAll: () => Promise<void>;
}

let provider: StorageProvider = createStorageProvider();

/** Permite inyectar otro proveedor (tests, backend REST futuro). */
export function setStorageProvider(p: StorageProvider): void {
  provider = p;
}

export const useProgressStore = create<ProgressState>((set, get) => ({
  loaded: false,
  progress: defaultProgress(),
  hydrate: async () => {
    try {
      const stored = await provider.load();
      set({ progress: stored ? migrateProgress(stored) : defaultProgress(), loaded: true });
    } catch (err) {
      console.warn('No se pudo cargar el progreso:', err);
      set({ loaded: true });
    }
  },
  recordAttempt: (result) => {
    const { progress, outcome } = applyAttempt(get().progress, result, Date.now());
    set({ progress });
    void provider.save(progress).catch((err) => console.warn('No se pudo guardar:', err));
    return outcome;
  },
  isLevelUnlocked: (id) => get().progress.unlockedLevels.includes(id),
  isCarUnlocked: (id) => get().progress.unlockedCars.includes(id),
  resetAll: async () => {
    await provider.clear().catch(() => undefined);
    set({ progress: defaultProgress() });
  },
}));
